<template>
  <v-app>
    <v-app-bar app dark color="blue darken-4">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>wakify</v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer absolute temporary v-model="drawer">
      <v-list nav dense>
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <v-list-item>
            <v-list-item-title @click="logout()">
              Abmelden
              <v-icon small color="red darken-2">mdi-logout</v-icon>
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    drawer: false
  }),
  methods: {
    logout() {
      localStorage.removeItem("driver");

      if (this.$router.currentRoute.name != "home") {
        this.$router.push("/");
        window.location.reload();
      } else {
        window.location.reload();
      }
    }
  }
};
</script>

<style>
a {
  text-decoration: none;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* LOADING */
.loading-circle {
  animation: loading 2s ease-in-out infinite;
  display: block;
  border: 4px solid #b7b7b7;
  border-top-color: transparent;
  border-radius: 50%;
  height: 30px;
  margin: 30px auto 0 auto;
  width: 30px;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
